<Level1Icon v-if="level === 1"></Level1Icon><Level2Icon v-else-if="level === 2"></Level2Icon><Level3Icon v-else-if="level === 3"></Level3Icon>